import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-vaccine-configuration',
  templateUrl: './vaccine-configuration.component.html',
  styleUrls: ['./vaccine-configuration.component.css']
})
export class VaccineConfigurationComponent implements OnInit {

 showDetails: boolean;
   showList: boolean = true;
   vaccineRegForm: FormGroup;
   lstGrid: any;
   dtOptions: any = {};
   dtRender: boolean = true
   eId: any;
   submitted: boolean = false;
   crntuser: any;
   userId: any;
   isEnableHumanMMU: boolean = false;
   is1962LiveStock: boolean = false;
   isEdit: boolean = false;
   screennames: any;
  vaccinationDurations: any[]=[];
  animalTypes: any[]=[];
  vaccines: any[]=[];
 
   get fc() { return this.vaccineRegForm.controls };
 
   constructor(
      private toastr: ToastrService
     , public fb: FormBuilder
     , public regService:RegistrationService
     , public el: ElementRef
     , public activeModal: NgbActiveModal) { }
 
   ngOnInit() {
     this.dtOptions = {
       pagingType: 'full_numbers',
       pageLength: 15,
       dom: 'Bfrtip',
       processing: true,
       buttons: [
 
         {
           extend: 'excelHtml5',
           title: 'Vccine configuration List',
           exportOptions: { columns: ':visible:not(:first-child)' }
         },
       ]
 
     };
     this.getFeaturePermission();
     this.sideMenupermission();
     this.crntuser = JSON.parse(sessionStorage.getItem('currentUser'));
     this.userId = this.crntuser.user_role_mapping[0].id
     this.formInIt();
     this.animalTypeList();
     this.VaccinesList();
     this.VaccineDurationList();
     this.LoadData();
   }
 
   sideMenupermission() {
     this.screennames = JSON.parse(sessionStorage.getItem('menu'));
 
   }
 
     getFeaturePermission() {
     var featureList: any = JSON.parse(localStorage.getItem('featuresList'));
     for (let i = 0; i < featureList.length; i++) {
       if (featureList[i].feature_id.feature_name == "1962LiveStock") {
         this.is1962LiveStock  = featureList[i].patient;
       }
        if (featureList[i].feature_id.feature_name == 'EnableHumanMMU') {
         this.isEnableHumanMMU = featureList[i].patient;
       }
     }
   }
 
   formInIt() {
     this.vaccineRegForm = this.fb.group({
       id: [0],
       vaccine_id: ['', Validators.required],
       animal_type_id: ['', Validators.required],
       dose_count: ['', Validators.required],
       vaccin_duration: [''],
       vaccin_duration_type_id: ['', Validators.required],
       is_active: [true],
       modified_by:sessionStorage.loginId
     })
   }
 
     LoadData() {
     this.dtRender = false
     this.regService.get(`masters/api/vaccine-configuration/list`).subscribe({
          next: res => {
            if (res.status == 'OK') {
               this.lstGrid = res.data??[]
                this.dtRender = true
             // this.toastr.success(res.message)
    
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
              this.dtRender = true
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
            this.dtRender = true
    
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
   }

  VaccineDurationList() {
     this.regService.get(`masters/api/vaccine-duration-period/active`).subscribe({
          next: res => {
            if (res.status == 'OK') {
               this.vaccinationDurations = res.data??[]
    
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
    
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
  }
  animalTypeList() {
     this.regService.get(`mvu/animal/getall`).subscribe({
          next: res => {
            if (res.status == 'OK') {
               this.animalTypes = res.data??[]
    
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
    
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
  }
  VaccinesList() {
     this.regService.get(`masters/api/vaccine/active`).subscribe({
          next: res => {
            if (res.status == 'OK') {
               this.vaccines = res.data??[]
    
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
    
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
  }
 
 
   openModal() {
     this.formInIt();
     this.eId = 0;
     this.submitted = false;
     this.dtRender = false
     this.showList = false
     this.showDetails = true;
   }
   onBack() {
     this.clear();
     this.dtRender = true
     this.showList = true
     this.showDetails = false;
     this.LoadData();
     this.isEdit = false
   }
 
   onEdit(item: any, type) {
     this.dtRender = false
     this.showDetails = true
     this.isEdit = true
     this.eId = item.id
     this.vaccineRegForm.patchValue(item)
   }
 
 
   onSave() {
 
     const payload = this.vaccineRegForm.getRawValue();
     this.submitted = true;
     if (this.vaccineRegForm.invalid) {
       this.toastr.info('Please Enter All Mandatory Fields');
       for (const key of Object.keys(this.vaccineRegForm.controls)) {
         if (this.vaccineRegForm.controls[key].invalid) {
           const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
           invalidControl.focus();
           return
         }
       }
       return false;
     }
 
     payload.id = this.isEdit ? this.eId : null
     this.regService.post(`masters/api/vaccine-configuration/save`,payload).subscribe({
       next: res => {
         if (res.status == 'OK' || res.status == 'CREATED') {
          this.toastr.success(res.message)
          this.onBack()
 
         } else {
           let errMsg: string = res.message;
           this.toastr.error(errMsg);
         }
       },
       error: (err: HttpErrorResponse) => {
         this.toastr.error(err.message);
 
       },
       complete: () => {
         // Any additional logic after patching values
       },
     });
   }
 
 
   clear() {
     this.vaccineRegForm.reset();
   }
 
   // toggleStatus(item: any) {
   //   const newStatus: boolean = !item.is_active;
   //   const action = newStatus ? 'Active' : 'In Active';
   //   const confirmMsg = `Are you sure you want to ${action} "${item.vaccine_name}"?`;
   //   if (!confirm(confirmMsg)) return;
   //   item.is_active = !item.is_active
   //   this.isEdit = true
   //   this.vaccineRegForm.patchValue(item)
   //   this.onSave();
   // }
 
 }
 
 
 